module.exports = __webpack_public_path__ + "static/media/old-west.de1646ee.jpg";